import isInstanceReduxUtil from 'modules/redux/utils/is-instance'
import { setReduxUtil } from 'modules/redux/utils/legacy/set'
import { isPlainObjectUtil } from 'packages/src'

/**
 * Returns the instance's merged data with the given updates or its changed attributes.
 *
 * @example
 *
 * ```js
 *
 *
 * // With the changed attribute
 * let instance = {
 *   data    : { a : 1, b : 1, c : 1 },
 *   changed : { a : 2, b : 2 }
 * }
 *
 * let data = getMergedDataReduxUtil(instance)
 * data => {
 *  data    : { a : 2, b : 2, c : 1 },
 *  changed : { a : 2, b : 2 }
 * }
 *
 * ```
 *
 * @param  {Instance} instance
 * @param  {Object} [updates]
 * @returns {Object|null}
 */
function getMergedDataReduxUtil (instance, updates) {
  if (!instance) {
    return null
  }
  let data = instance.data
  if (!data) {
    return null
  }
  updates = updates || instance.changed
  data = mergeDataReduxUtil(data, updates, '')
  return data
}

function mergeDataReduxUtil (data, updates, path = '') {
  if (path) {
    path += '.'
  }
  Object.keys(updates).forEach((key) => {
    const value = updates[key]
    const deepPath = path + key
    if (
      !isInstanceReduxUtil(value) &&
      isPlainObjectUtil(value)
    ) {
      data = mergeDataReduxUtil(data, value, deepPath)
      return
    }
    data = setReduxUtil(data, deepPath, value)
  })
  return data
}

export {
  getMergedDataReduxUtil
}
